import { defineFetcher } from "~/api/_common/defineFetcher"
import { POST } from "~/api/_common/http"

const PATH = "/course-application"

export type PostCourseApplicationBody = {
  course_id: number
  consultation: boolean
  preferred_date_times: string[]
  channel?: string
}

export type PostCourseApplication = {
  unique_id: unknown
}

export const fetchPostCourseApplication = defineFetcher(
  (body?: PostCourseApplicationBody): Promise<PostCourseApplication> => {
    return POST(PATH, body)
  }
)
